import { useState, useEffect, useCallback } from 'react';
import InvestorMetricsService from '../../../../../services/investor-metrics.service';

export const usePracticeMetrics = ({ dateRange = '30d', practiceId = null }) => {
  const [data, setData] = useState({
    activePractices: null,
    practiceLevelRetention: null,
    practicesByUsageTier: null,
    practiceEngagementTrends: null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const [active, retention, usageTiers, trends] = await Promise.all([
        InvestorMetricsService.getActivePractices({ dateRange }),
        InvestorMetricsService.getPracticeLevelRetention({ 
          dateRange: '90d', // Always use 90d for retention to show more weeks
          practiceId 
        }),
        InvestorMetricsService.getPracticesByUsageTier({ dateRange }),
        InvestorMetricsService.getPracticeEngagementTrends({ dateRange: '90d' }),
      ]);

      setData({
        activePractices: active,
        practiceLevelRetention: retention,
        practicesByUsageTier: usageTiers,
        practiceEngagementTrends: trends,
      });
    } catch (err) {
      console.error('Error fetching practice metrics:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [dateRange, practiceId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refetch = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch };
};
